import { render, staticRenderFns } from "./RejectWorkflowEmailSendDialog.vue?vue&type=template&id=3e5936e6"
import script from "./RejectWorkflowEmailSendDialog.vue?vue&type=script&lang=js"
export * from "./RejectWorkflowEmailSendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports